<template>
  <v-dialog v-model="modal" scrollable>
    <v-card>
      <v-card-title>
        Sélection de personne morale
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <search-by
              :datasource="datasource"
              attr="raisonSociale"
              i18n="recherche.rechercheSimple.personneMorale.search.raisonSociale"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <search-by
              :datasource="datasource"
              attr="departement"
              i18n="recherche.rechercheSimple.personneMorale.search.departement"
            />
          </v-col>
        </v-row>
        <datasource-table :datasource="datasource">
          <template #item.nomUsuel="{item}">
            <a @click="select(item)">
              {{ item.nomUsuel }}
            </a>
          </template>
          <template #item.raisonSociale="{item}">
            <a @click="select(item)">
              {{ item.raisonSociale }}
            </a>
          </template>
          <template #item.telephone="{item}">
            <span class="text-no-wrap">{{
              getInternational(item.telephone)
            }}</span>
          </template>
        </datasource-table>

        <v-card v-if="lienVersDemande">
          <v-col v-if="this.demandesPMVisible()">
            <v-card-title>
              Lier à une demande de création de personne morale
            </v-card-title>
            <datasource-table :datasource="datasourceDemandePM">
              <template #item.status="{item}">
                <a @click="select2(item)">
                  {{ item.status.libelle }}
                </a>
              </template>
              <template #item.concerne="{item}">
                <template v-if="item.concerne.libelle">
                  <a @click="select2(item)">
                    {{ item.concerne.libelle }}
                  </a>
                </template>
              </template>
              <template #item.dateModification="{item}">
                {{ formatDate(item.dateModification) }}
              </template>
              <template #item.dateCreation="{item}">
                {{ formatDate(item.dateCreation) }}
              </template>
            </datasource-table>
          </v-col>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal" text>
          {{ $t('button.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Datasource from '@/utils/datasource';
import { getInternational } from '@/components/telephone/telephoneUtil.js';
import moment from 'moment';

export default {
  props: {
    subtitle: {
      type: String,
    },
    lienVersDemande: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.lienVersDemande) {
      this.datasourceDemandePM.refresh();
    }
  },
  data() {
    const datasource = new Datasource('recherche/simple/personne-morale', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nomUsuel'],
      descending: [false],
      labelNamespace: 'recherche.rechercheSimple.personneMorale.list',
      args: {
        actif: true,
        noDataText: this.lienVersDemande
          ? this.$t(
              'recherche.rechercheSimple.personneMorale.list.search.notFound',
            )
          : null,
      },
      fields: [
        {
          value: 'nomUsuel',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: true,
        },
        {
          value: 'departement',
          sortable: false,
        },
        {
          value: 'ville',
          sortable: false,
        },
        {
          value: 'telephone',
          sortable: false,
        },
      ],
    });
    const datasourceDemandePM = new Datasource(
      'workflow/demandes/mes-demandes-pm-en-cours',
      {
        page: 1,
        rowsPerPage: 10,
        sortBy: 'dateCreation',
        descending: true,
        labelNamespace: 'demande.list',
        args: {
          actif: true,
        },
        title: 'Lier à une demande',
        fields: [
          {
            value: 'concerne',
            sortable: false,
          },
          {
            value: 'commentaire',
            sortable: false,
          },
          {
            value: 'dateCreation',
            sortable: true,
          },
          {
            value: 'dateModification',
            sortable: true,
          },
        ],
      },
    );
    return {
      datasource,
      datasourceDemandePM,
      modal: false,
      type: null,
      idDemande: null,
    };
  },
  methods: {
    getInternational,
    show(type) {
      this.modal = true;
      this.type = type;
    },
    select(item) {
      this.modal = false;

      const valeur = {
        id: item.id,
        raisonSociale: item.raisonSociale,
        nomUsuel: item.nomUsuel,
        type: this.type,
        idDemande: item.idDemande,
      };

      this.$emit('input', valeur);
    },
    select2(item) {
      this.$api(`workflow/demande/${item.id}`)
        .get()
        .then(response => {
          const valeur = response.body.objet;
          valeur.idDemande = response.body.id;
          this.select(valeur);
        });
    },
    demandesPMVisible() {
      return (
        this.lienVersDemande &&
        this.datasource.items.length === 0 &&
        this.datasourceDemandePM.items.length > 0
      );
    },
    closeModal() {
      this.modal = false;
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY [à] HH:mm') : null;
    },
  },
};
</script>
